//------------------- PESEL ----------------------------------------------------

app.directive('peselValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function peselValidation(pesel) {
                var reg = /^[0-9]{11}$/;
                if (reg.test(pesel) == false) {
                    ctrl.$setValidity('peselInvalid', false);
                } else {
                    var dig = ("" + pesel).split("");
                    var scales = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3],
                        control = 0;

                    for (var i = 0; i < scales.length; i++)
                        control += scales[i] * parseInt(dig[i], 10);

                    control = control % 10;
                    if (control == 0) {
                        control = 10;
                    }
                    control = 10 - control;
                    if (parseInt(dig[10], 10) == control)
                        ctrl.$setValidity('peselInvalid', true);
                    else
                        ctrl.$setValidity('peselInvalid', false);
                }

                return pesel;
            }

            ctrl.$parsers.push(peselValidation);
        }
    };
});

app.directive('peseluniqueValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function peseluniqueValidation(pesel) {
                var reg = /^[0-9]{11}$/;
                if (reg.test(pesel) == false) {
                    ctrl.$setValidity('peseluniqueInvalid', false);
                } else {
                    var dig = ("" + pesel).split("");
                    var scales = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3],
                        control = 0;

                    for (var i = 0; i < scales.length; i++)
                        control += scales[i] * parseInt(dig[i], 10);

                    control = control % 10;
                    if (control == 0) {
                        control = 10;
                    }
                    control = 10 - control;
                    if (parseInt(dig[10], 10) == control)
                        ctrl.$setValidity('peseluniqueInvalid', true);
                    else
                        ctrl.$setValidity('peseluniqueInvalid', false);
                }

                return pesel;
            }

            ctrl.$parsers.push(peseluniqueValidation);
        }
    };
});

//-------------------- NIP -----------------------------------------------------

app.directive('nipValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function nipValidation(nip) {
                if (nip == "") {
                    ctrl.$setValidity('nipInvalid', true);
                } else {
                    var clearNip = nip.replace(/-/g, "");
                    var reg = /^[0-9]{10}$/;
                    if (reg.test(clearNip) == false) {
                        ctrl.$setValidity('nipInvalid', false);
                    } else {
                        var dig = ("" + clearNip).split("");
                        var scales = [6, 5, 7, 2, 3, 4, 5, 6, 7],
                            control = 0;

                        for (var i = 0; i < scales.length; i++)
                            control += scales[i] * parseInt(dig[i], 10);

                        control = control % 11;

                        if (parseInt(dig[9], 10) == control)
                            ctrl.$setValidity('nipInvalid', true);
                        else
                            ctrl.$setValidity('nipInvalid', false);
                    }
                }

                return nip;
            }

            ctrl.$parsers.push(nipValidation);
        }
    };
});

//-------------------- POSTCODE ------------------------------------------------

app.directive('postcodeValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function postcodeValidation(postcode) {
                var reg = /^[0-9]{2}\-[0-9]{3}$/;

                if (postcode == "") {
                    ctrl.$setValidity('postcodeInvalid', true);
                } else if (reg.test(postcode) == false) {
                    ctrl.$setValidity('postcodeInvalid', false);
                } else {
                    ctrl.$setValidity('postcodeInvalid', true);
                }

                return postcode;
            }

            ctrl.$parsers.push(postcodeValidation);
        }
    };
});

//------------------- EMAIL ----------------------------------------------------

app.directive('emailValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function emailValidation(email) {
                if (email == "") {
                    ctrl.$setValidity('emailInvalid', true);
                } else {
                    var reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (reg.test(email) == false) {
                        ctrl.$setValidity('emailInvalid', false);
                    } else {
                        ctrl.$setValidity('emailInvalid', true);
                    }
                }

                return email;
            }

            ctrl.$parsers.push(emailValidation);
        }
    };
});

//--------------------- MOBILE -------------------------------------------------

app.directive('mobileValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function mobileValidation(mobile) {
                if (mobile == "") {
                    ctrl.$setValidity('mobileInvalid', true);
                } else {
                    var reg = /^[0-9]{9}$/;
                    if (reg.test(mobile) == false) {
                        ctrl.$setValidity('mobileInvalid', false);
                    } else {
                        ctrl.$setValidity('mobileInvalid', true);
                    }
                }

                return mobile;
            }

            ctrl.$parsers.push(mobileValidation);
        }
    };
});

//------------------- URL ------------------------------------------------------
app.directive('urlValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function urlValidation(url) {
                if (url == "") {
                    ctrl.$setValidity('urlInvalid', true);
                } else {
                    var reg = /^.*(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+\.,~#\?&\/=]*)$/;
                    if (reg.test(url) == false) {
                        ctrl.$setValidity('urlInvalid', false);
                    } else {
                        ctrl.$setValidity('urlInvalid', true);
                    }
                }

                return url;
            }

            ctrl.$parsers.push(urlValidation);
        }
    };
});

app.directive('mapurlValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function mapurlValidation(url) {
                if (url == "") {
                    ctrl.$setValidity('mapurlInvalid', true);
                } else {
                    var reg = /^https:\/\/www\.google\.(com|pl)\/maps\/.+$/;
                    if (reg.test(url) == false) {
                        ctrl.$setValidity('mapurlInvalid', false);
                    } else {
                        ctrl.$setValidity('mapurlInvalid', true);
                    }
                }

                return url;
            }

            ctrl.$parsers.push(mapurlValidation);
        }
    };
});

//--------------------- PASSWORD -----------------------------------------------

app.directive('passwordValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function passwordValidation(password) {
                if (password == "") {
                    ctrl.$setValidity('passwordInvalid', true);
                } else if (password.length < 8) {
                    ctrl.$setValidity('passwordInvalid', false);
                } else {
                    var reg = /^.*(?=.{3,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!$#%]).*$/;
                    if (reg.test(password) == false) {
                        ctrl.$setValidity('passwordInvalid', false);
                    } else {
                        ctrl.$setValidity('passwordInvalid', true);
                    }
                }

                return password;
            }

            ctrl.$parsers.push(passwordValidation);
        }
    };
});

//---------------------- SAME --------------------------------------------------

app.directive('sameaspasswordValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function sameaspasswordValidation(newpassword) {

                var password = attrs.sameaspassword;

// console.log(password);
// console.log(newpassword);

                if (!newpassword || !password || newpassword === "" || password === "") {
                    // It's valid because we have nothing to compare against
                    ctrl.$setValidity('sameaspasswordInvalid', true);
                } else {
                    ctrl.$setValidity('sameaspasswordInvalid', password == newpassword);
                }

                return newpassword;
            }

            ctrl.$parsers.push(sameaspasswordValidation);
        }
    };
});

//---------------------- DIFFERENT --------------------------------------------------

app.directive('differentpasswordValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function differentpasswordValidation(password) {

                var current = attrs.differentpassword;

                if (!current || !password) {
                    // It's valid because we have nothing to compare against
                    ctrl.$setValidity('differentpasswordInvalid', true);
                } else {
                    ctrl.$setValidity('differentpasswordInvalid', password != current);
                }

                return password;
            }

            ctrl.$parsers.push(differentpasswordValidation);
        }
    };
});

//--------------------- BIRTHDATE ----------------------------------------------------
app.directive('birthdateValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function birthdateValidation(date) {
                if (typeof date != "undefined" && date != null) {
                    var ageDifMs = Date.now() - date.getTime();
                    var ageDate = new Date(ageDifMs);
                    ctrl.$setValidity('birthdateInvalid', Math.abs(ageDate.getUTCFullYear() - 1970) >= 18);
                }
                return date;
            }

            ctrl.$parsers.push(birthdateValidation);
        }
    };
});

app.directive('futuredateValidation', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            function futuredateValidation(date) {
                if (typeof date != "undefined" && date != "") {
                    var today = new Date();

                    var day, monthIndex, year;

                    day = date.getDate();
                    monthIndex = date.getMonth();
                    year = date.getFullYear();
                    date = year + '-' + (monthIndex + 1 < 10 ? 0 : '') + (monthIndex + 1) + '-' + (day < 10 ? '0' : '') + day;

                    day = today.getDate();
                    monthIndex = today.getMonth();
                    year = today.getFullYear();
                    today = year + '-' + (monthIndex + 1 < 10 ? 0 : '') + (monthIndex + 1) + '-' + (day < 10 ? '0' : '') + day;


                    ctrl.$setValidity('futuredateInvalid', date >= today);
                } else {
                    ctrl.$setValidity('futuredateInvalid', true);
                }
                return date;
            }

            ctrl.$parsers.push(futuredateValidation);
        }
    };
});
